import { Navigate, Route, Routes } from "react-router-dom";

import { LanguageSync } from "@/components";
import { MainLayout } from "@/layouts";
import { LOCALE_PREFIXES, localizePath, ROUTES, SUPPORTED_LANGUAGES } from "@/navigations";
import {
  AboutPage,
  GetInvolvedPage,
  HomePage,
  NotFoundPage,
  SciencePage,
  TeamPage,
  UpdateDetailPage,
  UpdatesPage,
} from "@/pages";
import { LanguageEnum } from "@/types/enums";

const rel = (path: string) => path.replace(/^\//, "");

function LocaleRoutes({ lang }: { lang: LanguageEnum }) {
  return (
    <Route key={lang} path={LOCALE_PREFIXES[lang] || "/"} element={<LanguageSync lang={lang} />}>
      <Route element={<MainLayout />}>
        <Route index element={<HomePage />} />
        <Route path={rel(ROUTES.ABOUT)} element={<AboutPage />} />
        <Route path={rel(ROUTES.SCIENCE)} element={<SciencePage />} />
        <Route path={rel(ROUTES.TEAM)} element={<TeamPage />} />
        <Route path={rel(ROUTES.UPDATES)} element={<UpdatesPage />} />
        <Route path={rel(ROUTES.UPDATE_DETAIL)} element={<UpdateDetailPage />} />
        <Route path={rel(ROUTES.GET_INVOLVED)} element={<GetInvolvedPage />} />
        <Route path={rel(ROUTES.NOT_FOUND)} element={<NotFoundPage />} />
        <Route path="*" element={<Navigate to={localizePath(ROUTES.NOT_FOUND, lang)} replace />} />
      </Route>
    </Route>
  );
}

function App() {
  return <Routes>{SUPPORTED_LANGUAGES.map((lang) => LocaleRoutes({ lang }))}</Routes>;
}

export default App;
